module.exports = __webpack_public_path__ + "img/general-agile.23688480.png";